import { BenefitDocumentDto, CreateBenefitDocumentDto } from '@zorro/clients';

/** Picked file, persisted row, or uploaded-but-unsaved row. */
export type UploadableBenefitDocument =
  File | BenefitDocumentDto | CreateBenefitDocumentDto;

export const isPersistedDocument = (
  document: UploadableBenefitDocument
): document is BenefitDocumentDto =>
  !(document instanceof File) && 'id' in document;

export const isPendingDocument = (
  document: UploadableBenefitDocument
): document is CreateBenefitDocumentDto =>
  !(document instanceof File) && !('id' in document);

/** Stable list key per shape. */
export const getDocumentKey = (document: UploadableBenefitDocument): string => {
  // Names repeat; lastModified and the presigned URL don't.
  if (document instanceof File)
    return `${document.name}-${document.lastModified}`;
  return isPersistedDocument(document) ? document.id : document.documentUrl;
};
